import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { HomeComponent } from './home.component';
import { LandingUnidadesComponent } from '../landing-unidades/landing-unidades.component';
import { MediosPagoComponent } from '../medios-pago/medios-pago.component';
import { LandingAliadosComponent } from '../landing-aliados/landing-aliados.component';


export const routes: Routes = [
	{ path: '', component: HomeComponent },
];

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild(routes),
		SharedModule,
		
	],
	declarations: [
		HomeComponent,
		LandingUnidadesComponent,
		LandingAliadosComponent,
		MediosPagoComponent
	]
})
export class HomeModule { }
